import React, { useEffect, useState } from 'react';
import { RRule } from 'rrule';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

interface DeliveryProps {
  rRuleByDay: string;
  onChange: (deliveryDate: Date) => void;
}

export const Delivery: React.FC<DeliveryProps> = ({ rRuleByDay, onChange }) => {
  const [deliveryDate, setDeliveryDate] = useState('');
  const [days, setDays] = useState<Date[]>([]);

  useEffect(() => {
    const now = moment().utc();
    now.hour(0);
    now.minute(0);
    now.second(0);
    now.millisecond(0);

    if (rRuleByDay !== '') {
      const options = RRule.parseString(`RRULE:FREQ=WEEKLY;COUNT=30;INTERVAL=1;WKST=MO;BYDAY=${rRuleByDay}`);
      options.count = 6;
      options.dtstart = now.toDate();
      const rule = new RRule(options);
      setDays(rule.all());
    } else {
      setDays([]);
    }
  }, [rRuleByDay]);

  const updateDeliveryDateField = (event: any) => {
    if (!!event.target.value) {
      setDeliveryDate(event.target.value);
      onChange(new Date(event.target.value as string));
    }
  };

  const formattedDate = (ISOString: string) => {
    return moment(ISOString).format('dddd D MMMM');
  };

  return (
    <>
      {days.length > 0 ? (
        <>
          <Typography variant="h6" gutterBottom>
            Data di consegna
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="delivery-date">Giorno *</InputLabel>
                <Select
                  labelId="delivery-date"
                  name="date"
                  label={'Giorno *'}
                  value={deliveryDate}
                  onChange={updateDeliveryDateField}
                  renderValue={(value) => <span>{formattedDate(value as string)}</span>}
                  variant="outlined"
                >
                  {days.map((day) => (
                    <MenuItem key={day.toISOString()} value={day.toISOString()}>
                      {formattedDate(day.toISOString())}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </>
      ) : (
        <Typography variant="h6" gutterBottom>
          La data di consegna non può essere scelta per il tuo indirizzo, verrai contattato per accordare la consegna.
        </Typography>
      )}
    </>
  );
};
